module.exports = __webpack_public_path__ + "img/photo1.a1ee04c8.jpeg";